import React from "react";
import PropTypes from "prop-types";

import orderBy from "lodash/orderBy";

const Legend = ({ codes, type }) => {
  let result;
  let style = {};
  let title;
  if (type === "unavailable") {
    result = codes.filter(
      (code) =>
        (code.entity === "Call" &&
          code.field === "type" &&
          code.value === "PERSONAL") ||
        (code.entity === "Call" &&
          code.field === "workplace" &&
          code.value === "ONSITE")
    );
    style = {
      maxWidth: "30%",
      margin: "auto"
    };
    title = "UNAVAILABLE";
  } else {
    result = codes.filter(
      (code) => code.entity === "Call" && code.field === "status"
    );
    title = "AVAILABLE";
  }
  return (
    <>
      <h4 style={{ textAlign: "center", paddingTop: "10px" }}>{title}:</h4>
      <div className="call-status-legend" style={style}>
        {orderBy(result, "order").map((code, i) => (
          <div key={i} className="legend-item">
            <span
              className="legend-badge"
              style={{
                backgroundColor: code.color
              }}
            />
            <span className="legend-text">{code.label}</span>
          </div>
        ))}
      </div>
    </>
  );
};

Legend.propTypes = {
  codes: PropTypes.array,
  type: PropTypes.string
};
export default Legend;
